import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import generatePlaceholders from 'util/generatePlaceholders';
import { BreadcrumbsSchema, PageTypeSchema } from 'components/Schema';
import PageHeader from 'components/PageHeader';
import PageContent from 'components/PageContent';
import NotFoundPage from 'components/pages/status/NotFoundPage';
import DeeplinkSchema from 'components/Schema/DeeplinkSchema';

import { GENRES_PAGE_TITLE, MOODS_PAGE_TITLE, TILE_SIZES } from 'globalConst/const';
import { SCHEMA_PAGE_TYPE } from 'globalConst/schema-const';
import HeaderBanner from 'components/HeaderBanner';
import ContentTypeComponent from 'components/ContentTypeComponent';

const DEFAULT_PAGE_SETTINGS = {
  pageType: 'genrePage',
};

const DEFAULT_COLLECTION_PROPS = {
  tileSizes: TILE_SIZES.SMALL,
  rows: 1,
  showNowPlayingInfo: true,
};

class GenrePage extends PureComponent {
  static propTypes = {
    error: PropTypes.bool,
    genre: PropTypes.shape({
      brandColor: PropTypes.string,
      headerImage: PropTypes.object,
      logo: PropTypes.object,
      logoSecondary: PropTypes.object,
      title: PropTypes.string,
      contentTypeId: PropTypes.string,
      slug: PropTypes.string,
      subtitle: PropTypes.string,
    }),
    isComponentLoading: PropTypes.bool,
    overview: PropTypes.shape({
      brandColor: PropTypes.string,
      headerImage: PropTypes.object,
      logo: PropTypes.object,
      logoSecondary: PropTypes.object,
      title: PropTypes.string,
      sections: PropTypes.array,
      subtitle: PropTypes.string,
    }),
  };

  static defaultProps = {
    error: false,
    genre: null,
    isComponentLoading: false,
    overview: null,
  };

  renderPlaceholder = () => {
    const placeholder = {
      uuid: 'placeholder-collection',
      contentTypeId: 'stationCollection',
      display: 'tiles',
      ...DEFAULT_COLLECTION_PROPS,
      showMore: {
        variant: 'hideShowMore',
      },
      collection: generatePlaceholders(20),
    };

    return (
      <Fragment>
        <PageHeader page={DEFAULT_PAGE_SETTINGS} isComponentLoading />
        <PageContent>
          <ContentTypeComponent {...placeholder} />
        </PageContent>
      </Fragment>
    );
  };

  render() {
    const { error, genre, isComponentLoading, overview } = this.props;

    if (isComponentLoading) {
      return this.renderPlaceholder();
    }

    const { sections, ...otherOverviewProps } = overview || {};

    if (error || !sections || !sections.length) {
      return <NotFoundPage />;
    }

    return (
      <Fragment>
        <PageTypeSchema type={SCHEMA_PAGE_TYPE.COLLECTION_PAGE} metadata={genre} />
        <DeeplinkSchema deeplinks={[{ link: `${genre.contentTypeId}/${genre.slug}` }]} />
        <PageHeader {...genre} {...otherOverviewProps} page={DEFAULT_PAGE_SETTINGS} />
        <HeaderBanner
          imageUrl={overview?.headerImage?.url}
          logoUrl={genre?.logoSecondary?.url || genre?.logo?.url}
          color={genre.brandColor}
          title={genre.title}
          description={genre.subtitle ?? overview.subtitle}
          // metadata={subSlug ? metadataBrand : metadataStation}
        />
        <BreadcrumbsSchema
          level2={genre.contentTypeId === 'mood' ? MOODS_PAGE_TITLE : GENRES_PAGE_TITLE}
          level3={genre.title}
        />
        <PageContent>
          {sections &&
            sections.map((section) => (
              <ContentTypeComponent key={section.uuid} {...DEFAULT_COLLECTION_PROPS} {...section} />
            ))}
        </PageContent>
      </Fragment>
    );
  }
}

export default GenrePage;
